var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "overlay" } }, [
    _c("div", { attrs: { id: "content" } }, [
      _c("div", { staticClass: "row row-margin" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-outline-primary",
              on: { click: _vm.add },
            },
            [_vm._v(" 追加する ")]
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-outline-info modal-close",
              on: { click: _vm.closeModal },
            },
            [_vm._v(" キャンセルする ")]
          ),
        ]),
      ]),
      _c("div", { staticClass: "row row-margin" }, [
        _c("div", { staticClass: "col-12 form-inline" }, [
          _c("div", { staticClass: "col-12" }, [
            _vm._v(" メンバーを検索して [追加する] をクリックしてください "),
          ]),
          _c(
            "div",
            { staticClass: "border rounded", attrs: { id: "select-form" } },
            [
              _vm.isAddUsers
                ? _c("p", { attrs: { id: "select-caution" } })
                : _vm._e(),
              _vm._l(_vm.addUsers, function (addUser) {
                return _c(
                  "div",
                  {
                    key: addUser.id,
                    staticClass: "form-inline border rounded select-item",
                  },
                  [
                    _vm._v(" " + _vm._s(addUser.userName) + " "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm .border.border-0",
                        on: {
                          click: function ($event) {
                            return _vm.removeUser(addUser.id)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "times-solid-sm",
                          attrs: { src: "/times-solid.svg" },
                        }),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
      ]),
      _c(
        "form",
        {
          staticClass: "input-group",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.searchUser(_vm.searchKey, _vm.selectedOrgId)
            },
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchKey,
                expression: "searchKey",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "ID、名称、かな" },
            domProps: { value: _vm.searchKey },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.searchKey = $event.target.value
              },
            },
          }),
          _vm._m(0),
        ]
      ),
      _c("div", { staticClass: "row", staticStyle: { "margin-top": "10px" } }, [
        _vm._m(1),
        _c("div", { staticClass: "col-6" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedOrgId,
                  expression: "selectedOrgId",
                },
              ],
              staticClass: "form-control",
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedOrgId = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  function ($event) {
                    return _vm.searchUser(_vm.searchKey, _vm.selectedOrgId)
                  },
                ],
              },
            },
            [
              _c("option", { attrs: { value: "" } }, [
                _vm._v("所属（組織）を選択してください"),
              ]),
              _vm._l(_vm.organizationOptions, function (option) {
                return _c(
                  "option",
                  { key: option.id, domProps: { value: option.id } },
                  [_vm._v(" " + _vm._s(option.displayName) + " ")]
                )
              }),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "col-6 d-flex align-items-center" }, [
          _vm.selectedOrgId !== ""
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-sm btn-outline-info modal-close text-left",
                    on: { click: _vm.clearOrgSelection },
                  },
                  [_vm._v(" 所属（組織）の選択を解除する ")]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._m(2),
      _c("div", { staticClass: "table-scroll" }, [
        _c("table", { staticClass: "table table-sm table-hover form-table" }, [
          _vm._m(3),
          _c(
            "tbody",
            _vm._l(_vm.searchUsers, function (searchUser) {
              return _c("tr", { key: searchUser.id }, [
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "btn-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.addUser(searchUser.id)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "plus-solid",
                        attrs: { src: "/plus-solid.svg" },
                      }),
                    ]
                  ),
                ]),
                _c("td", [_vm._v(_vm._s(searchUser.userCode))]),
                _c("td", [_vm._v(_vm._s(searchUser.userName))]),
                _c("td", [_vm._v(_vm._s(searchUser.organization.affiliation))]),
              ])
            }),
            0
          ),
        ]),
      ]),
      _c("nav", { attrs: { "aria-label": "pager" } }, [
        _c("ul", { staticClass: "pagination justify-content-center" }, [
          _vm.isPrev
            ? _c("li", { on: { click: _vm.goPrev } }, [
                _c("a", { staticClass: "btn page-link rounded-pill" }, [
                  _vm._v("← 前"),
                ]),
              ])
            : _vm._e(),
          _vm.isPrev || _vm.isNext
            ? _c("li", { staticClass: "mx-2" }, [
                _c("a", { staticClass: "btn page-link rounded-pill" }, [
                  _vm._v("現在"),
                ]),
              ])
            : _vm._e(),
          _vm.isNext
            ? _c("li", { on: { click: _vm.goNext } }, [
                _c("a", { staticClass: "btn page-link rounded-pill" }, [
                  _vm._v("次 →"),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-append" }, [
      _c(
        "button",
        { staticClass: "btn btn-secondary", attrs: { type: "submit" } },
        [
          _c("img", {
            staticClass: "search-solid",
            attrs: { src: "/search-solid.svg" },
          }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-12 d-flex d-flex align-items-center" },
      [_c("label", [_vm._v("所属（組織）からメンバーを検索する")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [_c("p")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", {
          staticStyle: { width: "50px", border: "none" },
          attrs: { scope: "col" },
        }),
        _c(
          "th",
          {
            staticStyle: { width: "95px", border: "none" },
            attrs: { scope: "col" },
          },
          [_vm._v("ID")]
        ),
        _c(
          "th",
          {
            staticStyle: { width: "110px", border: "none" },
            attrs: { scope: "col" },
          },
          [_vm._v("ユーザー名")]
        ),
        _c(
          "th",
          {
            staticStyle: { width: "110px", border: "none" },
            attrs: { scope: "col" },
          },
          [_vm._v("所属")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }